export enum LoanStatusType {
    DELINQUENT = 'delinquent',
    NON_ACCRUAL = 'nonaccrual',
    WRITTEN_OFF = 'writtenoff',
    MATURED = 'matured',
}

export default LoanStatusType;
